import Cookies from "js-cookie";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
    Grow, Card, Button, Popper, AppBar, Toolbar,
    IconButton, CardActions, ClickAwayListener,
} from "@material-ui/core";

import Drawer from "./Drawer"
import logo from "../../assets/logo.png";
import userAvatar from "../../assets/user.png";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
    },
    menuButton: {
        marginRight: theme.spacing(1),
    },
    title: {
        flexGrow: 1,
        color: "#fff",
    },
}));

export default function MyAppBar() {
    const history = useHistory();
    if (Cookies.get("is_authenticated") === "false" || !Cookies.get("is_authenticated")) { history.push("/"); }
    const classes = useStyles();

    const [anchorEl, setAnchorEl] = useState(false);
    const handleMenu = (event) => { setAnchorEl(anchorEl ? null : event.currentTarget) };
    const avatar = localStorage.getItem("avatar");

    function Sair() {
        Cookies.remove("is_authenticated");
        history.push("/");
    }

    return (
        <div className="background">
            <div className={classes.root}>

                <AppBar position="fixed">
                    <Toolbar variant="dense">
                        <Drawer />
                        <img
                            src={logo}
                            width="100"
                            alt="PAEweb"
                            onClick={() => history.push("/dashboard")}
                            className="login-logo"
                        />
                        {/* MENU USUARIO */}
                        <div style={{
                            display: "flex",
                            flexDirection: "row-reverse",
                            width: "100%",
                            whiteSpace: "nowrap",
                            overflow: "hidden"
                        }}>
                            <IconButton
                                aria-label="usuário"
                                aria-controls="menu-usuario"
                                aria-haspopup="true"
                                onClick={handleMenu}
                                color="inherit"
                                className="userIcon"
                            >
                                <img
                                    width="30"
                                    height="30"
                                    alt="Usuário"
                                    src={avatar !== "" ? `data:image/jpeg;base64,${avatar}` : userAvatar}
                                />
                            </IconButton>
                            <Popper
                                id="menu-usuario"
                                anchorEl={anchorEl}
                                open={anchorEl && anchorEl.getAttribute("aria-controls") === "menu-usuario" ? true : false}
                                onClose={() => { setAnchorEl(null) }}
                                transition
                            >
                                {({ TransitionProps }) => (
                                    <ClickAwayListener onClickAway={() => { setAnchorEl(null) }}>
                                        <Grow {...TransitionProps} timeout={350}>
                                            <Card elevation={4}>
                                                <CardActions className="space-between">
                                                    <Button style={{ whiteSpace: 'nowrap', overflow: 'hidden' }} size="small" onClick={() => Sair()} className="text-danger">
                                                        Sair
                                                    </Button>
                                                </CardActions>
                                            </Card>
                                        </Grow>
                                    </ClickAwayListener>
                                )}
                            </Popper>
                        </div>
                    </Toolbar>
                </AppBar>
            </div>
        </div>
    );
}
